(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Elemente, die beim Hereinscrollen sanft einblenden.
  // Die Klasse `mt-reveal` setzt ausschließlich dieses Skript – ohne JS bleibt
  // alles sichtbar.
  const selectors = [
    // v7-Sections
    '.shopify-section--mytuning-finder .mytuning-finder__layout > *',
    '.shopify-section--mytuning-trust .mytuning-trust__item',
    '.shopify-section--mytuning-categories .mytuning-category',
    '.shopify-section--featured-collections .section-stack > *',
    '.shopify-section--mytuning-manifesto .mytuning-manifesto__content > *',
    '.shopify-section--mytuning-product-trust .mytuning-product-trust__card',
    '.shopify-section--mytuning-product-modules .mytuning-product-module',
    '.shopify-section--mytuning-review-wall .mytuning-review-card',
    '.shopify-section--mytuning-assurance .mytuning-assurance__card',
    // v8-Pflegelinie
    '.mt-care__head',
    '.mt-reviews__head',
    '.mt-care-products__grid > *',
    '.mt-care-kit__media',
    '.mt-care-kit__body',
    '.mt-care-step',
    '.mt-reviews__grid > *',
    '.mt-versus__row',
    '.mt-care-cta__content > *',
    '.mt-compare'
    // Produktkarten NICHT hier aufnehmen: Prestige blendet sie selbst ein
    // (Attribut `reveal-on-scroll` + theme.js). Doppelte Animation vermeiden.
  ];

  const QUERY = selectors.join(',');
  const pending = new Set();

  const show = (element) => {
    element.classList.add('mt-is-visible');
    pending.delete(element);
  };

  const showAll = () => [...pending].forEach(show);

  // Sichtbarkeit über die Geometrie statt über IntersectionObserver:
  // funktioniert unabhängig davon, in welchem Container das Theme scrollt,
  // und lässt nie ein Element unsichtbar zurück.
  const sweep = () => {
    if (pending.size === 0) return;
    const limit = window.innerHeight * 0.94;
    [...pending].forEach((element) => {
      const box = element.getBoundingClientRect();
      if (box.bottom > 0 && box.top < limit) show(element);
    });
  };

  let queued = false;
  const requestSweep = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sweep();
    });
  };

  const collect = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    const found = [...scope.querySelectorAll(QUERY)];
    if (scope !== document && scope.matches?.(QUERY)) found.unshift(scope);
    const fresh = found.filter((element) => !element.classList.contains('mt-reveal'));
    if (fresh.length === 0) return;

    if (reducedMotion.matches) {
      fresh.forEach((element) => {
        element.classList.add('mt-reveal', 'mt-is-visible');
      });
      return;
    }

    // Verzögerung je Geschwistergruppe, damit Karten nacheinander erscheinen
    // und nicht nach ihrer Position im gesamten Dokument.
    const seen = new Map();
    fresh.forEach((element) => {
      const parent = element.parentElement || document.body;
      const index = seen.get(parent) ?? 0;
      seen.set(parent, index + 1);
      element.style.setProperty('--mt-reveal-delay', `${Math.min(index, 5) * 70}ms`);
      element.classList.add('mt-reveal');
      pending.add(element);
    });

    requestSweep();
  };

  const start = () => {
    collect(document);
    sweep();
    // Scroll-Events steigen nicht auf: In der Capture-Phase von document
    // werden sie aus jedem Scroll-Container erfasst.
    document.addEventListener('scroll', requestSweep, { passive: true, capture: true });
    window.addEventListener('resize', requestSweep, { passive: true });
    // Not-Aus: Sollte aus irgendeinem Grund kein Sweep greifen, ist nach
    // dreieinhalb Sekunden garantiert alles sichtbar.
    setTimeout(showAll, 3500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // Theme-Editor und nachgeladene Sections
  document.addEventListener('shopify:section:load', (event) => {
    collect(event.target);
    sweep();
  });

  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) showAll();
  });
})();
